export function InvestmentIcon(props) {
  return (
    <svg viewBox="38 35 125 130" {...props}>
      <g fillRule="evenodd">
        <path
          fill="#EAEAD9"
          d="M163 52c0 9.389-7.387 17-16.5 17S130 61.389 130 52s7.387-17 16.5-17S163 42.611 163 52z"
        />
        <path
          fill="#B87E58"
          d="M78.751 165H38v-4.852h35.95v-36.394h42.378V91H163v4.852h-41.871v32.755H78.75V165z"
        />
      </g>
    </svg>
  );
}